import {sendNumberForRegistration, logIn, registerWithSoc, requestChangePhoneCode, requestChangePhoneCodeValid} from '../../../logic/api.js';
import {extractNumbers, formatPhoneNumber, setPasswordTimer} from '../../../logic/utils';
import {loginToVK} from '../../../logic/auth/vk';
import {loginToFb} from '../../../logic/auth/fb';
import {setAuthToken, setUserId} from '../../../logic/authHelpers';
import initialState from '../../../redux/initialState';
import config from '../../../config';

export function openRegistrationPopup() {
  return {
    type: 'REGISTRATION:POPUP-OPEN'
  };
}

export function closeRegistrationPopup() {
  return {
    type: 'REGISTRATION:POPUP-CLOSE'
  };
}

export function setRefId(refId) {
  return {
    type: 'REGISTRATION:SET-REF-ID',
    refId
  };
}

export function onPhoneNumberChange(value) {
  return {
    type: 'REGISTRATION:NUMBER-CHANGE',
    phoneNumber: '+' + extractNumbers(value)
  };
}

export const requestChangePhonePass = (newPhone) => (dispatch) => {
  setPasswordTimer();
  dispatch({
    type: 'REGISTRATION:REQUEST-CHANGE-PHONE-CODE'
  });

  return requestChangePhoneCode(formatPhoneNumber(newPhone))
  .then((res) => {
      if(res.error)
        dispatch(onSendNumberFail(res.error));
      else
        dispatch(onSendNumberSuccess(res));

      return res;
  });
};

export function sendNumber(value, openSignInIfRegistered = false) {
  return (dispatch, getState ) => {
    setPasswordTimer();
    const refId = getState().registrationPopupReducer.refId;

    dispatch({
      type: 'REGISTRATION:NUMBER-SENT'
    });

    return sendNumberForRegistration(formatPhoneNumber(value), refId)
    .then((res) => {
      if (res.error && res.error === config.userAlreadyRegisteredServerErrorText && openSignInIfRegistered) {
        return res;
      }
      if (res.error) {
        dispatch(onSendNumberFail(res.error));
        return res;
      }
      dispatch(onSendNumberSuccess(res));
      return res;
    })
    .catch((err) => dispatch(onSendNumberFail(err)));
  };
}

export const onSendNumberSuccess = (res) => {
  return {
    type: 'REGISTRATION:NUMBER-SENT-SUCCESS',
    res
  };
};

const onSendNumberFail = (err) => ({
  type: 'REGISTRATION:NUMBER-SENT-FAIL',
  err
});

export function returnToFirstStep() {
  return {
    type: 'REGISTRATION:RETURN-TO-FIRST-STEP'
  };
}

export function onPasswordChange({target: {value}}) {
  return {
    type: 'REGISTRATION:PASSWORD-CHANGE',
    password: value
  };
}

export const requestChangePhone = (codeHash) => (dispatch) => {
  dispatch({
    type: 'REGISTRATION:REQUEST-CHANGE-PHONE'
  });

  return requestChangePhoneCodeValid(codeHash)
  .then((res) => {
    if (res.error)
      dispatch(requestChangePhoneCodeValidError(res.error));
    else
      dispatch(requestChangePhoneCodeValidSuccess(res));
    return res;
  })
  .catch((err) => dispatch(requestChangePhoneCodeValidError(err)));
};

const requestChangePhoneCodeValidSuccess = () => ({
  type: 'REGISTRATION:REQUEST-CHANGE-PHONE-SUCCESS',
  regInputCurStep: 1
});

const requestChangePhoneCodeValidError = () => ({
  type: 'REGISTRATION:REQUEST-CHANGE-PHONE-ERROR'
});

export function submitPassword(password) {
  return (dispatch) => {
    dispatch({
      type: 'REGISTRATION:LOGIN-REQUEST-SENT',
      password
    });
    return logIn({password})
    .then((res) => {
      if (res.error) {
        return dispatch(onSubmitPasswordFail(res.error));
      }
      dispatch(onSubmitPasswordSuccess(res));
    })
    // .catch((err) => dispatch(onSubmitPasswordSuccess(err)));
    .catch((err) => dispatch(onSubmitPasswordFail(err)));
  };
}

const onSubmitPasswordFail = (err) => ({
  type: 'REGISTRATION:LOGIN-REQUEST-SENT-FAIL',
  err
});

const onSubmitPasswordSuccess = ({access_token, userId, userData}) => {
  setAuthToken(access_token);
  setUserId(userId);
  return {
    type: 'REGISTRATION:LOGIN-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  };
};

export function registerToVk() {
  return (dispatch, getState) => {
    dispatch({
      type: 'REGISTRATION:VK-REQUEST-SENT'
    });
    const refId = getState().registrationPopupReducer.refId;

    loginToVK()
    .then((code) =>
      registerWithSoc({
        code,
        type: 'VK'
      },
      refId))
    .then((res) => {
      if (res.error) {
        //todo remove this
        alert(res.error);
        return dispatch(onRegisterToVKFail(res.error));
      }
      dispatch(onRegisterToVKSuccess(res));
    })
    .catch((err) => dispatch(onRegisterToVKFail(err)));
  };
}

const onRegisterToVKSuccess = ({access_token, userId, userData}) => (dispatch) => {
  setAuthToken(access_token);
  setUserId(userId);
  dispatch({
    type: 'REGISTRATION:VK-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  });
  dispatch(closeRegistrationPopup());
};

const onRegisterToVKFail = (err) => ({
  type: 'REGISTRATION:VK-REQUEST-SENT-FAIL',
  err
});

export function registerToFb() {
  return (dispatch) => {
    dispatch({
      type: 'REGISTRATION:FB-REQUEST-SENT'
    });
    loginToFb()
    .then((code) =>
      registerWithSoc({
        code,
        type: 'FB'
      }))
    .then((res) => {
      if (res.error) {
        //todo remove this
        alert(res.error);
        return dispatch(onRegisterToFBFail(res.error));
      }
      dispatch(onRegisterToFBSuccess(res));
    })
    .catch((err) => dispatch(onRegisterToFBFail(err)));
  };
}

const onRegisterToFBSuccess = ({access_token, userId, userData}) => (dispatch) => {
  setAuthToken(access_token);
  setUserId(userId);
  dispatch({
    type: 'REGISTRATION:FB-REQUEST-SENT-SUCCESS',
    access_token,
    userId,
    userData
  });
  dispatch(closeRegistrationPopup());
};

export function onRegisterToFBFail(err) {
  return {
    type: 'REGISTRATION:FB-REQUEST-SENT-FAIL',
    err
  };
}

export const resetRegErrors = () => ({
  type: 'REGISTRATION:RESET-ERRORS'
});

export default
function registrationPopupReducer(state = initialState.registrationPopupState, action) {
  switch (action.type) {
    case 'REGISTRATION:POPUP-OPEN':
      return {
        ...state,
        isOpen: true
      };

    case 'REGISTRATION:POPUP-CLOSE':
      return {
        ...state,
        isOpen: false,
        sentPasswordErr: '',
        sentNumberErr: '',
        phoneNumber: '',
        password: ''
      };

    case 'REGISTRATION:NUMBER-CHANGE':
      return {
        ...state,
        phoneNumber: action.phoneNumber
      };

    case 'REGISTRATION:PASSWORD-CHANGE':
      return {
        ...state,
        password: action.password
      };

    case 'REGISTRATION:NUMBER-SENT-FAIL':
      return {
        ...state,
        sentNumberErr: action.err
      };

    case 'REGISTRATION:NUMBER-SENT-SUCCESS':
      return {
        ...state,
        regInputCurStep: 2,
        sentNumberErr: ''
      };

    case 'REGISTRATION:RETURN-TO-FIRST-STEP':
      return {
        ...state,
        regInputCurStep: 1
      };

    case 'REGISTRATION:LOGIN-REQUEST-SENT-SUCCESS':
      return initialState.registrationPopupState;

    case 'REGISTRATION:LOGIN-REQUEST-SENT-FAIL':
      return {
        ...state,
        sentPasswordErr: action.err
      };

    case 'REGISTRATION:VK-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        vkErr: ''
      };

    case 'REGISTRATION:FB-REQUEST-SENT-SUCCESS':
      return {
        ...state,
        fbErr: ''
      };

    case 'REGISTRATION:VK-REQUEST-SENT-FAIL':
      return {
        ...state,
        vkErr: action.err
      };

    case 'REGISTRATION:FB-REQUEST-SENT-FAIL':
      return {
        ...state,
        fbErr: action.err
      };

    case 'REGISTRATION:RESET-ERRORS':
      return {
        ...state,
        sentNumberErr: '',
        sentPasswordErr: ''
      };

    case 'REGISTRATION:REQUEST-CHANGE-PHONE-SUCCESS':
      return {
        ...state,
        regInputCurStep: action.regInputCurStep
      };

    case 'REGISTRATION:SET-REF-ID':
      return {
        ...state,
        refId: action.refId
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/redux/registrationPopupActions.js
 **/